import { render, staticRenderFns } from "./EmailSidebar.vue?vue&type=template&id=29764023&scoped=true&"
import script from "./EmailSidebar.vue?vue&type=script&lang=js&"
export * from "./EmailSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EmailSidebar.vue?vue&type=style&index=0&id=29764023&lang=scss&scoped=true&"
import style1 from "./EmailSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29764023",
  null
  
)

export default component.exports